import { getConfigForImportedTest } from 'Components/Worksheets/Config';
import { IConfigFunctionArgs } from 'Components/Worksheets/Core';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';
import { pathAsArray, pathAsString } from 'Lib/Object/Path/shared';
import * as oPath from '../../../../../../Lib/Object/Path/Immutable';
import qestIds from '../../../../QestIds';
import getMeasuredUsingConfig from '../../../measuredUsingConfig';
import { GrainSize } from '../../../types';
import getLabelConfig from './labelConfig';

const getDefaultReadability = (grainSize: GrainSize) => {
  let defaultReadability;
  switch (grainSize) {
    case GrainSize.Coarse:
      defaultReadability = 1;
      break;
    case GrainSize.Medium:
      defaultReadability = 0.1;
      break;
    case GrainSize.Fine:
    default:
      defaultReadability = 0.01;
      break;
  }

  return {
    defaultReadability,
    defaultUom: 'g',
  };
};

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.DryingTray.ContainerLabel`]: { maxLength: 20 },
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: { uom: 'h', format: { nearest: 0.01 } },
      [`${prefix}.Results.MoistureContentPercent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.UncorrectedMoisturePercent`]: { format: { nearest: 0.1 } },
      [`${prefix}.ImagesAndRemarks.Remarks`]: { maxLength: 255 },
      [`${prefix}.ImagesAndRemarks.InternalRemarks`]: { maxLength: 255 },
      [`${prefix}.Preparation.Slope`]: { format: { nearest: 0.01 } },
      [`${prefix}.Preparation.Intercept`]: { format: { nearest: 0.01 } },
      [`${prefix}.Preparation.AssociatedMoistureCorrelation.ExternalTest.Results.Slope`]: { format: { nearest: 0.01 } },
      [`${prefix}.Preparation.AssociatedMoistureCorrelation.ExternalTest.Results.Intercept`]: {
        format: { nearest: 0.01 },
      },
    },
    getConfigForImportedTest(
      qestIds.moistureCorrelation.AS_1289_2_3_1,
      `${prefix}.Preparation.AssociatedMoistureCorrelation`
    ),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getLabelConfig(prefix),
    {
      // Set balance readability defaults - dependent on Grain Size
      // TODO: We take the name of the config prop then go back up and down to get grain size.
      // This is a fairly awkward workaround for issues providing config for an array of unknown length
      // that varies by index (as this config is used by moisture contents in specimens for other worksheets)
      [`${prefix}.Equipment.DryMassBalance`]: (configArgs: IConfigFunctionArgs) =>
        getDefaultReadability(
          oPath.get(
            configArgs.worksheet,
            pathAsString([...pathAsArray(configArgs.name).slice(0, -2), 'Preparation.GrainSize'])
          ) as GrainSize
        ),
      [`${prefix}.Equipment.Balance`]: (configArgs: IConfigFunctionArgs) =>
        getDefaultReadability(
          oPath.get(
            configArgs.worksheet,
            pathAsString([...pathAsArray(configArgs.name).slice(0, -2), 'Preparation.GrainSize'])
          ) as GrainSize
        ),
    }
  );

export { getConfig };

export default {
  [qestIds.moistureContent.AS_1289_2_1_6.rev2005]: getConfig,
};
